// extracted by mini-css-extract-plugin
export default {"crossWrap":"crossIcon_crossWrap__4OpBy","inclinedLineOne":"crossIcon_inclinedLineOne__kb6Pd","inclinedLineTwo":"crossIcon_inclinedLineTwo__4keg9"};